import { ACCOUNT_STATE_FILTERS, parseStateCounts } from "@/constants/accountState";

// Last counts per endpoint + params. A filter change remounts the page (see
// below), so this keeps the chip numbers on screen while the fresh count of
// the new page instance is on its way instead of blinking them away.
const lastCounts = Object.create(null);

// The search term typed in the list, handed from the page instance a filter
// change destroys to the one it creates ({ fullPath, term }; null when idle).
let carriedSearch = null;

// Owner item 3.1: the Active / Inactive / Banned chip row of the drivers and
// riders lists (AccountStateFilter.vue).
// The selected chip lives in ?state= and is changed with $router.replace.
// App.vue keys the page on $route.fullPath, so a filter change remounts the
// page: the list params and the counts always start from the URL, and the
// DataTable never sees its params change under it. The host gives its
// DataTable ref="list" and :initial-search="listSearch", so the search term
// survives that remount.
// The host page defines two computeds: stateCountsUrl (string) and
// stateCountsParams (plain object, only keys that are set).
export default {
  data() {
    const carried = carriedSearch;
    carriedSearch = null;
    return {
      stateCounts: null,
      stateWindowDays: null,
      stateCountsFailed: false,
      listSearch: carried && carried.fullPath === this.$route.fullPath ? carried.term : "",
    };
  },
  computed: {
    accountState() {
      const state = this.$route.query.state;
      return ACCOUNT_STATE_FILTERS.indexOf(state) !== -1 ? state : "all";
    },
  },
  created() {
    this.loadStateCounts();
  },
  methods: {
    // dropKeys: query keys that must not survive the change (the drivers page
    // drops ?tab=pending, which would otherwise reopen the Pending tab).
    setAccountState(state, dropKeys = []) {
      if (state === this.accountState) return;
      const query = { ...this.$route.query };
      dropKeys.forEach((key) => delete query[key]);
      if (state === "all") delete query.state;
      else query.state = state;
      this.replaceListQuery(query);
    },
    replaceListQuery(query) {
      const location = { path: this.$route.path, query };
      const table = this.$refs.list;
      const term = table && typeof table.search === "string" ? table.search.trim() : "";
      carriedSearch = term ? { fullPath: this.$router.resolve(location).route.fullPath, term } : null;
      // A duplicated or superseded navigation rejects; nothing was remounted,
      // so the term has no one to go to.
      this.$router.replace(location).catch(() => {
        carriedSearch = null;
      });
    },
    loadStateCounts() {
      const params = this.stateCountsParams || {};
      const key = this.stateCountsUrl + "?" + new URLSearchParams(params).toString();
      if (lastCounts[key]) this.applyStateCounts(lastCounts[key]);
      this.axios
        .get(this.stateCountsUrl, { params })
        .then(({ data }) => {
          const parsed = parseStateCounts(data && data.data);
          if (!parsed) throw new Error("unexpected state-counts payload");
          lastCounts[key] = parsed;
          this.applyStateCounts(parsed);
        })
        .catch(() => {
          // The counts are a convenience: hide them, the list still works.
          delete lastCounts[key];
          this.stateCounts = null;
          this.stateWindowDays = null;
          this.stateCountsFailed = true;
        });
    },
    applyStateCounts(parsed) {
      this.stateCounts = parsed.counts;
      this.stateWindowDays = parsed.windowDays;
      this.stateCountsFailed = false;
    },
  },
};
